import { useCallback, useEffect, useState } from 'react';

const monthFormatter = new Intl.DateTimeFormat('ru-RU', { month: 'long', year: 'numeric', timeZone: 'UTC' });

function formatDate(value) {
    if (!value) return '';
    return monthFormatter.format(new Date(`${value}T00:00:00Z`)).replace(/^./, (letter) => letter.toUpperCase());
}

function Experience() {
    const [state, setState] = useState({ status: 'loading', items: [] });

    const loadExperience = useCallback(async () => {
        setState((current) => ({ ...current, status: 'loading' }));
        try {
            const response = await fetch('/api/experience/');
            if (!response.ok) throw new Error('Experience request failed');
            setState({ status: 'success', items: await response.json() });
        } catch (error) {
            setState({ status: 'error', items: [] });
        }
    }, []);

    useEffect(() => { loadExperience(); }, [loadExperience]);

    if (state.status === 'loading') return <p className="experience-state" role="status">Загружаю опыт работы…</p>;
    if (state.status === 'error') {
        return <div className="experience-state" role="alert"><p>Не удалось загрузить опыт работы.</p><button className="text-button" type="button" onClick={loadExperience}>Попробовать снова</button></div>;
    }
    if (!state.items.length) return <p className="experience-state">Информация об опыте скоро появится.</p>;

    return (
        <div className="timeline">
            {state.items.map((item, index) => {
                const responsibilities = item.items.filter(({ kind }) => kind === 'responsibility');
                const achievements = item.items.filter(({ kind }) => kind === 'achievement');
                return (
                    <article className="timeline-item" key={`${item.company}-${item.start_date}`}>
                        <div className="timeline-meta">
                            <span className="timeline-number">{String(index + 1).padStart(2, '0')}</span>
                            <p><time dateTime={item.start_date}>{formatDate(item.start_date)}</time> — {item.is_current ? 'настоящее время' : <time dateTime={item.end_date}>{formatDate(item.end_date)}</time>}</p>
                        </div>
                        <div className="timeline-content">
                            <p className="company">{item.company}{item.location ? `, ${item.location}` : ''}</p>
                            <h3>{item.position}</h3>
                            {item.project_summary && <p className="project-summary">{item.project_summary}</p>}
                            {responsibilities.length > 0 && <ul>{responsibilities.map(({ text }) => <li key={text}>{text}</li>)}</ul>}
                            {achievements.map(({ text }) => <p className="achievement" key={text}><strong>Результат:</strong> {text}</p>)}
                        </div>
                    </article>
                );
            })}
        </div>
    );
}

export default Experience;
